export * from './lib/proposal-product-details.component';
